import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons'
import { isMobile } from 'utils'
import { useStyles } from './styles'

export const UnmuteButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    const classes = useStyles()
    return (
        <div id="unmute-btn" className={classes.root} onClick={onClick}>
            <FontAwesomeIcon className={classes.icon} icon={faVolumeMute} />
            {`${isMobile() ? 'TAP' : 'CLICK'} TO UNMUTE VIDEO`}
        </div>
    )
}

export default React.memo(UnmuteButton)
